/* import __COLOCATED_TEMPLATE__ from './top-banner-selector.hbs'; */
/* RESPONSIBLE TEAM: team-self-serve */
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import Component from '@glimmer/component';
import RouteRegexes from 'embercom/lib/route-regexes';
import moment from 'moment-timezone';

export default class TopBannerSelector extends Component {
  @service router;
  @service cardlessTrialService;
  @service appService;
  @service finUsageService;

  @tracked finLimitReachedDismissed = false;
  @tracked finApproachingLimitDismissed = false;

  constructor(owner, args) {
    super(owner, args);
    this.loadDismissalStates();
  }

  get app() {
    return this.appService.app;
  }

  get finLimitReachedDismissalKey() {
    return `fin-limit-reached-banner-${this.app?.id}`;
  }

  get finApproachingLimitDismissalKey() {
    return `fin-approaching-limit-banner-${this.app?.id}`;
  }

  get appIsTestApp() {
    return this.cardlessTrialService.isTestApp;
  }

  get appIsNotInTrial() {
    return !this.cardlessTrialService.inTrialOrExpiredTrial;
  }

  get currentPath() {
    return this.router.currentRouteName;
  }

  get showBeginTrialBanner() {
    if (!this.appService.app) {
      return false;
    }
    return (
      !this.isOnExcludedRoutesForCardlessTrialBanner &&
      this.cardlessTrialService.inTrialOrExpiredTrial &&
      !this.appIsTestApp &&
      !this.appService.app?.hideGlobalTrialBanner
    );
  }

  get showUsageBasedGiftBanner() {
    return this.app?.shouldSeeUsageBasedGiftBanner;
  }

  get showFinLimitReachedBanner() {
    return (
      this.appIsNotInTrial &&
      this.finUsageService.isFinResolutionsLimitReached &&
      !this.finLimitReachedDismissed
    );
  }

  get showFinApproachingLimitBanner() {
    return (
      this.appIsNotInTrial &&
      this.finUsageService.areUsedResolutions90PercentOfLimit &&
      !this.finApproachingLimitDismissed
    );
  }

  get isOnExcludedRoutesForCardlessTrialBanner() {
    return this.router.currentRouteName.match(RouteRegexes.excludedForCardlessTrialBanner);
  }

  get isOnFinAiAgentSection() {
    return RouteRegexes.automation.root.test(this.currentPath);
  }

  get shouldShowFinIncentivesBanner() {
    return (
      this.app?.isEligibleForFinIncentiveOffer &&
      this.app?.canSeeFinIncentiveOffer &&
      !this.isOnFinAiAgentSection
    );
  }

  isDismissedInLast24Hours(key) {
    let expirationTimestamp = localStorage.getItem(key);
    if (!expirationTimestamp) {
      return false;
    }
    let expirationMoment = moment(expirationTimestamp);
    let now = moment();
    return now.isBefore(expirationMoment);
  }

  dismissBanner(key) {
    let expirationTime = moment().add(24, 'hours').toISOString();
    localStorage.setItem(key, expirationTime);
  }

  loadDismissalStates() {
    this.finLimitReachedDismissed = this.isDismissedInLast24Hours(this.finLimitReachedDismissalKey);
    this.finApproachingLimitDismissed = this.isDismissedInLast24Hours(
      this.finApproachingLimitDismissalKey,
    );
  }

  @action
  dismissFinLimitReachedBanner() {
    this.dismissBanner(this.finLimitReachedDismissalKey);
    this.finLimitReachedDismissed = true;
  }

  @action
  dismissFinApproachingLimitBanner() {
    this.dismissBanner(this.finApproachingLimitDismissalKey);
    this.finApproachingLimitDismissed = true;
  }
}
